// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginView_login__ZDkZ0 {
  min-height: calc(100vh - 134px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
@media (min-width: 320px) {
  .LoginView_login__ZDkZ0 {
    min-height: calc(100vh - 301.5px);
  }
}

.LoginView_card__kB6-j {
  max-width: 600px;
  min-width: 320px;
  width: 100%;
  margin: 0;
}
@media (min-width: 1023px) {
  .LoginView_card__kB6-j {
    min-width: 400px;
  }
}

.LoginView_inputError__0Tkwj {
  color: #df6767;
}

.LoginView_center__FAWaY {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/auth/views/LoginView/LoginView.module.scss","webpack://./src/_common/scss/_media.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAIA;EACE,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAHF;ACKI;EDPJ;IAQI,iCAAA;EAFF;AACF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAFF;ACKI;EDPJ;IAOI,gBAAA;EADF;AACF;;AAIA;EACE,cEfM;AFcR;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AADF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.login {\n  min-height: calc(100vh - $navbar-height * 2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 $padding-m;\n\n  @include media(xss) {\n    min-height: calc(100vh - $navbar-height * 4.5);\n  }\n}\n\n.card {\n  max-width: 600px;\n  min-width: 320px;\n  width: 100%;\n  margin: 0;\n\n  @include media(md) {\n    min-width: 400px;\n  }\n}\n\n.inputError {\n  color: $error;\n}\n\n.center {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `LoginView_login__ZDkZ0`,
	"card": `LoginView_card__kB6-j`,
	"inputError": `LoginView_inputError__0Tkwj`,
	"center": `LoginView_center__FAWaY`
};
export default ___CSS_LOADER_EXPORT___;
